import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Lazily-loaded Stripe.js singleton for the Sales Room card flows (add-card
 * SetupIntent + winner SCA recovery). The publishable key is a build-time env
 * var (pk_…) — the only Stripe key that ships to the browser. Returns null
 * when the key is unset so callers can show a graceful "payments unavailable"
 * state instead of throwing.
 */

const pk = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '';

let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!pk) {
    console.warn('[stripe] VITE_STRIPE_PUBLISHABLE_KEY is not set — card flows disabled.');
    return Promise.resolve(null);
  }
  if (!stripePromise) stripePromise = loadStripe(pk);
  return stripePromise;
}

export const stripeConfigured = !!pk;
